import { ApolloClient } from 'apollo-client'
import fetch from 'unfetch'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'

const httpLink = createHttpLink({
  uri: window.CONFIG.STORE_URL,
  fetch: fetch
})

const cache = new InMemoryCache({
  dataIdFromObject: object => {
    switch (object.__typename) {
      case 'Product': return `${object.id}${object.description}`
      default: return defaultDataIdFromObject(object)
    }
  }
})

export default new ApolloClient({
  link: httpLink,
  cache
})
